/**
 * @param error error from the BE
 * @returns error message or null if error message not found
 *
 * For some endpoints BE implements the following strategy: the error object has
 * the `error` property being a JSON encoded object with the `message` property.
 * We get the interior `message`.
 *
 * Create CA and possibly other endpoints store the error messages as
 * error.error.message.
 *
 * The error format is not documented.  At the time of writing the function is
 * known to work for deleting crypto tokens and crypto token keys.
 */
export function extractErrorMessage(error: unknown): string | null {
  if (
    error &&
    typeof error === 'object' &&
    'error' in error &&
    error.error &&
    typeof error.error === 'object' &&
    'message' in error.error &&
    error.error.message &&
    typeof error.error.message === 'string'
  ) {
    return error.error.message;
  }
  if (
    !error ||
    typeof error !== 'object' ||
    !('error' in error) ||
    !error.error ||
    typeof error.error !== 'string'
  ) {
    return null;
  }
  let errorObj: unknown;
  try {
    errorObj = JSON.parse(error.error);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    // JSON is invalid
    return null;
  }
  if (
    !errorObj ||
    typeof errorObj !== 'object' ||
    !('message' in errorObj) ||
    typeof errorObj.message !== 'string'
  ) {
    return null;
  }
  return errorObj.message;
}
